import React, { useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { BsDownload } from 'react-icons/bs';
import TextField from '@material-ui/core/TextField';
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/core/styles';

import Loader from 'src/components/loader';
import Aside from '../../components/aside';
import NoDataPage from 'src/components/noDataFound/No-data';
import { ApiPost, Bucket } from 'src/services/http-service';
import { searching } from 'src/redux/reducer/searchFilterSlice';


const YourPurchases = () => {
  const [data, setdata] = useState([]);
  const [loading, setloading] = React.useState<boolean>(false);
  const [currentpage, setcurrentpage] = useState(1);
  const [pagesize, setpagesize] = useState(10);
  const [totalpage, settotalpage] = useState(0);


  const dispatch = useDispatch();

  const [month, setmonth] = React.useState<any>(moment(new Date()).format('M'));
  const [year, setyear] = React.useState<any>(
    moment(new Date()).format('YYYY')
  );
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(
    new Date()
  );
  const fetchData = async (month:any,year:any,page:any,limit:any) => {
    setloading(true);
    const body = {
      month: JSON.parse(month),
      year: JSON.parse(year),
      page:page,
      limit:limit
    };
    await ApiPost('/get_purchase', body)
      .then((res: any) => {
      
        setdata(res?.data?.data);
        settotalpage(res?.data?.state?.page_limit);
        setloading(false);
      })
      .catch((e) => {
        setloading(false);
      });
  };
  React.useEffect(() => {
    fetchData(month,year,currentpage, pagesize);
  }, [currentpage, pagesize]);
  const handleChange = (e: any, i: any) => {
    
    setcurrentpage(i);
  };
  const handleonchnagespagination = (e: any) => {
   
    setpagesize(e.target.value);
  };
  const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200
    }
  }));
  const handleDateChange = (date: any | null) => {
    if (date.target.value) {
      setmonth(moment(date.target.value).format('M'));
    setyear(moment(date.target.value).format('YYYY'));
    setSelectedDate(date.target.value);
    fetchData(moment(date.target.value).format('M'),moment(date.target.value).format('YYYY'),currentpage, pagesize)
    } else {
      handleReset();
    }
    
  };
  const handleReset = () => {
    setmonth(moment().format('M'));
    setyear(moment().format('YYYY'));
    fetchData( moment().format('M'),
    moment().format('YYYY'),currentpage, pagesize)

  };
  const classes = useStyles();
  const download = (v: any) => {
    
    let name = v.posts[0]?.title;
    let a = document.createElement('a');
    let url = Bucket + v?.posts[0]?.sourceFile;
    a.href = url;
    a.setAttribute('download', name);
    a.click();
  };

  return (
    <div className="primary-content-area container content-padding grid-left-sidebar">
      <Aside />
      <div className="main-content-area">
        <div className="page-title-section">
          <h2>
            <span className="gradient-text">Your </span> Purchases
          </h2>
        </div>
        <div className="purchases-list">
          <div className="filterable-bar">
            <form id="creators-filter-form">
              <div className="filter-options">
                <TextField
                  id="date"
                  type="month"
                  placeholder="Select Month"
                  defaultValue={moment(Date()).format('YYYY-MM')}
                  className={`${classes?.textField} textheight`}
                  style={{ height: '43px' }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={handleDateChange}
                />
              </div>
              {/* <div className="filter-button">
                <button
                  type="button"
                  className="btn btn-normal btn-dark create-collection waves-effect waves-button waves-float waves-light hower-effect w-100"
                  onClick={fetchData}
                >
                  Filter
                </button>
              </div> */}
            </form>
          </div>
          {loading ? (
            <Loader />
          ) : data.length ? (
            <table className="content-table">
              <thead>
                <tr>
                  <th scope="col" className="heading-label">
                    Item details
                  </th>
                  <th scope="col" className="heading-label">
                    Date
                  </th>
                  <th scope="col" className="heading-label">
                    License
                  </th>
                  <th scope="col" className="heading-label">
                    Price
                  </th>
                  <th scope="col" className="heading-label"></th>
                </tr>
              </thead>
              <tbody>
                {data?.map((e: any) => {
                  return (
                    <>
                      <tr>
                        <td data-label="Item details">
                          <div className="product-info">
                            <div className="product-thumb">
                              <Link
                                to={
                                  e?.posts[0]?._id
                                    ? `/productdetail/${e?.posts[0]?.title}/${e?.posts[0]?._id}`
                                    : ''
                                }
                                onClick={() => {
                                  dispatch(searching(''));
                                }}
                              >
                                <img
                                  height="50px"
                                  width="100px"
                                  src={
                                    e?.posts[0]?.thumbnail
                                      ? e?.posts[0]?.thumbnail.split('/')[2] ==
                                        'lh3.googleusercontent.com'
                                        ? e?.posts[0]?.thumbnail
                                        : Bucket + e?.posts[0]?.thumbnail
                                      : '/Image/avatar.png'
                                  }
                                  alt="user-avatar"
                                />
                              </Link>
                            </div>
                            <div className="product-details">
                              <div className="product-name">
                                <Link
                                  to={
                                    e?.posts[0]?._id
                                      ? `/productdetail/${e?.posts[0]?.title}/${e?.posts[0]?._id}`
                                      : ''
                                  }
                                  onClick={() => {
                                    dispatch(searching(''));
                                  }}
                                >
                                  {e?.posts[0]?.title}
                                </Link>
                              </div>
                              <div className="product-meta">
                                <Link
                                  to={
                                    e?.posts[0]?.category[0]?._id &&
                                    `/explore-items/${e?.posts[0]?.category[0]?.name}`
                                  }
                                  className="item-category ui-templates"
                                >
                                  <div className="item-category ui-templates">
                                    {e?.posts[0]?.category[0]?.name}
                                  </div>
                                </Link>
                                <div className="product-seller">
                                  <Link
                                    to={
                                      e?.posts[0]?.user[0]?._id
                                        ? `/public/${e?.posts[0]?.user[0]?._id}/profile`
                                        : ''
                                    }
                                    onClick={() => {
                                      dispatch(searching(''));
                                    }}
                                  >
                                    @{e?.posts[0]?.user[0]?.username}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td data-label="Date">
                          {moment(e?.createdAt).format('MMM DD,YYYY')}
                        </td>
                        <td data-label="License">
                          {e?.licenseType === 0 && 'Regular'}
                          {e?.licenseType === 1 && 'Commercial'}
                          {e?.licenseType === 2 && 'Extended'}
                        </td>
                        <td data-label="Price" className="price">
                          ${e?.originalprice}
                        </td>
                        <td>
                          <button
                            className="download"
                            onClick={() => download(e)}
                          >
                            <svg className="crumina-icon">
                              <BsDownload />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <NoDataPage
              title="Result Not Found"
              image="/Image/Icons/NotFound.png"
              desc="Please try again with another keywords or maybe use generic term"
              status={true}
              btnName="Go to Home"
              path="/"
            />
          )}
          {/* <div className="discount-section">
                        <form className="cryptoki-form" id="discount-form">
                            <span className="label">Redeem Code</span>
                            <input type="text" placeholder="CRYP1258OFF" />
                            <button className="btn btn-normal btn-dark waves-effect waves-button waves-float waves-light" type="submit">Redeem!</button>
                        </form>
                    </div> */}
        </div>
        {totalpage > 1 && <div className="d-flex justify-content-between mt-5  pt-10">
              <div className="my-2">
              <Pagination
                  count={totalpage}
                  page={currentpage}
                  onChange={handleChange}
                  variant="outlined"
                  shape="rounded"
                  className="pagination_"
                />
              </div>
              <div className="my-2">
                <div className="d-flex align-items-center pagination-drpdown">
                  <select
                    className="form-control pagination-drpdown1 dropdownPage"
                    id="kt_datatable_search_status"
                    onChange={(e) => handleonchnagespagination(e)}
                    value={pagesize}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                  </select>
                </div>
              </div>
            </div>
            }
      </div>
    </div>
  );
};

export default YourPurchases;
